/**
 * Position für fixed Popover/Dropdown — flippt nach oben wenn unten kein Platz (iOS Safe Area / Browser-Chrome).
 */
export function computeFixedPopoverPosition(
  anchorRect,
  { width = 260, heightEstimate = 320, gap = 8, margin = 8 } = {},
) {
  const vv = typeof window !== "undefined" ? window.visualViewport : null;
  const vw = vv?.width ?? window.innerWidth ?? document.documentElement.clientWidth;
  const vh = vv?.height ?? window.innerHeight ?? document.documentElement.clientHeight;
  const vt = vv?.offsetTop ?? 0;
  const vl = vv?.offsetLeft ?? 0;

  const left = Math.max(
    margin + vl,
    Math.min(anchorRect.right - width, vl + vw - width - margin),
  );

  const spaceBelow = vh + vt - anchorRect.bottom - gap;
  const spaceAbove = anchorRect.top - vt - gap;
  const openUp = spaceBelow < Math.min(heightEstimate, 180) && spaceAbove > spaceBelow;

  let top = openUp
    ? anchorRect.top - gap - Math.min(heightEstimate, Math.max(spaceAbove, 120))
    : anchorRect.bottom + gap;

  top = Math.max(vt + margin, Math.min(top, vt + vh - margin - 80));

  return { top, left, width };
}
